import { render, staticRenderFns } from "./test-layout.vue?vue&type=template&id=7c9daca0&"
import script from "./test-layout.vue?vue&type=script&lang=js&"
export * from "./test-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports